import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { ContextService, LoginData } from '../../context.service';

@Component({
    selector: 'mutara-phone',
    templateUrl: './phone.component.html',
    standalone: false
})
export class PhoneComponent extends FieldType<FieldTypeConfig> implements OnInit {
  login: LoginData | undefined;
  phoneMask: string = '(000) 000-0099 99999';
  countryKey: string | undefined;
  countryTab: string | undefined;

  constructor(private context: ContextService) {
    super();
  }

  ngOnInit(): void {
    this.context.subscribeTo("loginData", (login : LoginData | undefined) => this.login = login);
    if ( this.field.modelOptions ) { this.field.modelOptions.updateOn = 'blur'; }
    //this.countryTab = this.form;
    this.countryKey = this.props.countryKey;
  }

  get mask(): string {
    let countryCode = !!this.countryKey ? this.formState.cdf.getValue(this.countryKey) : 'USA';
    return countryCode == 'USA' ? '(000) 000-0000 999999' : '000 000 0099 99999';
  }

}